import React from 'react';
import { useBackgroundJobs } from '../../lib/backgroundJobs';
import { LogoLoader } from './logo-loader';

// Floating status pill for work running in the background (see lib/backgroundJobs).
export default function BackgroundJobs() {
  const jobs = useBackgroundJobs().filter((job) => job.visible);
  if (!jobs.length) return null;
  const [current, ...rest] = jobs;
  const count = current.total ? ` ${current.done ?? 0}/${current.total}` : '';

  return (
    <div className="bg-jobs" role="status" aria-live="polite">
      <span aria-hidden="true"><LogoLoader size={28} showLabel={false} /></span>
      <div className="bg-jobs__text">
        <strong>{current.label}<span className="tabular">{count}</span></strong>
        {rest.length > 0 && <small>+{rest.length} more running</small>}
      </div>
    </div>
  );
}
